import { FunctionComponent } from "react";

interface ContainerProps {
    progress: number
}

const ProgressBar: FunctionComponent<ContainerProps> = (props) => {
    const progress = props.progress

    return (
        <div className="row fixed-bottom">
            <div className="col-12">
                <div className="progress">
                    <div className="progress-bar" style={{ width: progress+"%" }}></div>
                </div>
            </div>
        </div>
    )
}
export default ProgressBar;
